import { post } from '../Services/http';
import {
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  PRODUCTS_SET_LIST_TYPE,
  PRODUCTS_SET_IS_LOADING,
  PRODUCTS_SET_HAS_REAR_PRODUCTS,
} from '../constants';
import { setPriceDisplayQuantity } from './PriceDisplayQuantity.action';
import { receiveVariantPicker } from './VariantPicker.action';
import { getFacetFiltersAsQuery } from './FacetedSearch.action';

export const setListType = (listType) => {
  // Fire and forget
  post(`/api/productsview/setListType?listType=${listType}`);

  return {
    type: PRODUCTS_SET_LIST_TYPE,
    payload: {
      listType,
    },
  };
};

export const setHasRearProducts = (hasRearProducts) => ({
  type: PRODUCTS_SET_HAS_REAR_PRODUCTS,
  payload: {
    hasRearProducts,
  },
});

export const receiveProductsWrapper = (productsWrapper) => ({
  type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  payload: {
    productsWrapper,
  },
});

export const togglePriceDisplayQuantity = (
  productsWrapper,
  filterQuery = null,
  abortController = null
) => (dispatch, getState) => {
  const facetFilters = getState().facetedSearch.facetFilters;
  dispatch(setProductsLoading(true));

  let queryString = filterQuery ?? getFacetFiltersAsQuery(facetFilters);

  return post(
    `/api/productsview/togglePriceDisplayQuantity?${queryString}`,
    productsWrapper,
    abortController
  )
    .then((res) => {
      if (res.status == 204) {
        location.reload();
        return;
      }
      return res.json();
    })
    .then((data) => {
      if (data) {
        dispatch(setPriceDisplayQuantity(data.priceDisplayQuantity));
        dispatch(receiveProductsWrapper(data));
        return data;
      }
    })
    .finally(() => dispatch(setProductsLoading(false)));
};

export const setProductsInProductsView = (
  products,
  isWheelBuilder = false
) => ({
  type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  payload: {
    productsWrapper: {
      products,
    },
    isWheelBuilder,
  },
});

export const setProductsLoading = (isLoading) => ({
  type: PRODUCTS_SET_IS_LOADING,
  payload: {
    isLoading,
  },
});
